import { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { LocaleContext } from "../../../../routing/LangRouter";
import { DialogContent, Divider, Grid } from "@mui/material";
import axios from "axios";
import BASE_URL from "../../../../constants/baseUrls";
import { formatPersianDate } from "../../../../utils/date";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

//import general components
import MobileHeader from "../../../../components/common/mobile-header/mobile-header";
import BaseDialog from "../../../common/base-dialog/base-dialog";

//import images and icons
import { Add, ArrowForward, AttachCircle, Send } from "iconsax-react";

//styles
import "./chat-request.scss";
import { navigateToLoginPage } from "../../../../utils/utility";

function ChatRequest({ handleChangeStatusButton, chatRequestID }) {
    //general
    const navigate = useNavigate();
    const location = useLocation();
    const { locale } = useContext(LocaleContext);
    const accessToken = localStorage.getItem("accessToken");
    const { t } = useTranslation();

    //request to get one request
    const [request, setRequest] = useState("");
    const getRequest = async () => {
        try {
            const response = await axios.get(`${BASE_URL}/account/user/request/`, {
                params: {
                    id: chatRequestID,
                },
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });
            setRequest(response.data);
        } catch (error) {
            if (error.response.status === 401) {
                localStorage.clear();
                navigateToLoginPage(navigate, locale, location);
            } else {
                toast.error(t("Toast Messages.Error Occurred"), { toastId: "custom-id-yes" });
            }
        }
    };

    useEffect(() => {
        getRequest();
    }, []);

    //send message
    const [messageText, setMessageText] = useState("");
    const [messageFile, setMessageFile] = useState("");

    const handleMessageChange = event => {
        const { value } = event.target;
        setMessageText(value);
    };

    const handleFileChange = event => {
        if (event.target.files) {
            const file = event.target.files[0];
            setMessageFile(file);
        }
    };

    //remove file
    const removeFile = () => {
        setMessageFile("");
    };

    const sendMessage = async () => {
        let data = new FormData();
        data.append("attached_file", messageFile);
        data.append("text", messageText);

        const response = await axios.post(`${BASE_URL}/account/user/request/`, data, {
            params: {
                id: chatRequestID,
            },
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        });
        try {
            if (response.status === 200) {
                toast.success(response.data.message, { toastId: "custom-id-yes" });
                getRequest();
            }
            setMessageText("");
            setMessageFile("");
        } catch (error) {
            if (error.response.status === 401) {
                localStorage.clear();
                navigateToLoginPage(navigate, locale, location);
            } else {
                toast.success(t("Toast Messages.Error Occurred"), { toastId: "custom-id-yes" });
            }
        }
    };

    const [open, setOpen] = useState(false);
    const [image, setImage] = useState();
    const showImage = image => {
        setOpen(true);
        setImage("https://api.atripa.com" + image);
    };

    //format date in Persian format
    const formatDate = date => {
        return formatPersianDate(date, {
            day: "numeric",
            month: "long",
            year: undefined,
            weekday: "long",
        });
    };

    return (
        <Grid className="chat-request" container item xs={12}>
            <MobileHeader title={t("support")} justifyContent="center" handleClick={() => handleChangeStatusButton(false)} />
            <Grid className="chat-request__header" container item xs={12}>
                <Grid item xs={4}></Grid>
                <Grid className="chat-request__title-box" container item xs={12} md={4} justifyContent="center">
                    <span className="chat-request__title">{request.type}</span>
                </Grid>
                <Grid
                    className="chat-request__undo"
                    container
                    item
                    xs={4}
                    columnGap={1}
                    justifyContent="flex-end"
                    alignItems="center"
                    display={{ xs: "none", md: "flex" }}
                    onClick={() => handleChangeStatusButton(false)}
                >
                    {t("backToList")}
                    <ArrowForward color="var(--primary-color)" />
                </Grid>
            </Grid>
            <Divider width="100%" sx={{ borderBottom: "1px solid var(--medium-gray-color)" }} />

            {request ? (
                <Grid className="chat-request__container" container item xs={12} rowGap={5} mb={10}>
                    {request.chats.map(chat => {
                        return (
                            <Grid container item xs={12} justifyContent="space-between" alignItems="center">
                                <Grid
                                    className={`chat-request__chat-box ${
                                        chat.type === 1 ? "chat-request__chat-box--admin" : "chat-request__chat-box--user"
                                    } `}
                                    container
                                    item
                                    xs={12}
                                    md={6.5}
                                    justifyContent="center"
                                    order={chat.type === 1 ? 4 : 1}
                                >
                                    <Grid
                                        className={`chat-request__header-chat-box ${
                                            chat.type === 1 ? "chat-request__header-chat-box--admin" : "chat-request__header-chat-box--user"
                                        } `}
                                        container
                                        alignItems="center"
                                        item
                                        xs={10}
                                    >
                                        {chat.user}
                                    </Grid>
                                    <Grid className="chat-request__chat-text" container item xs={10} direction="column" alignItems="flex-start">
                                        <span>{chat.text}</span>
                                        {!!chat?.attach ? (
                                            <span className="chat-request__chat-file" onClick={() => showImage(chat?.attach)}>
                                                <img src={"https://api.atripa.com" + chat?.attach} />
                                            </span>
                                        ) : null}
                                    </Grid>
                                    <Grid className="line" item xs={10} display={{ xs: "flex", md: "none" }}>
                                        <Divider width="100%" sx={{ borderBottom: "1px solid var(--light-color)" }} />
                                    </Grid>
                                    <Grid container item xs={12} justifyContent="flex-start" display={{ xs: "flex", md: "none" }}>
                                        <span className="chat-request__chat-date">
                                            {(chat.date ? formatDate(chat?.date.split("T")[0]) : "") +
                                                " - " +
                                                (chat.date ? chat.date.split("T")[1].split(":", 2).join(":") : "")}
                                        </span>
                                    </Grid>
                                </Grid>

                                <Grid item xs={1.25} display={{ xs: "none", md: "flex" }} order={chat.type === 1 ? 3 : 2}>
                                    <Divider width="100%" sx={{ borderBottom: "1px solid var(--gray-color)" }} />
                                </Grid>

                                <Grid
                                    container
                                    item
                                    xs={2}
                                    justifyContent="center"
                                    display={{ xs: "none", md: "flex" }}
                                    order={chat.type === 1 ? 2 : 3}
                                >
                                    <span className="chat-request__chat-date">
                                        {(chat.date ? formatDate(chat?.date.split("T")[0]) : "") +
                                            " - " +
                                            (chat.date ? chat.date.split("T")[1].split(":", 2).join(":") : "")}
                                    </span>
                                </Grid>

                                <Grid item xs={1.25} display={{ xs: "none", md: "flex" }} order={chat.type === 1 ? 1 : 4}>
                                    <Divider width="100%" sx={{ borderBottom: "1px solid var(--gray-color)" }} />
                                </Grid>
                            </Grid>
                        );
                    })}

                    <Grid className="chat-request__new-message" container item xs={12} justifyContent="space-between" alignItems="center">
                        <Grid container item xs="auto" alignItems="center">
                            <Send size="32" color="var(--primary-color)" variant="Bold" onClick={sendMessage} cursor="pointer" />
                        </Grid>
                        <Grid container item xs={8} md={10} alignItems="center">
                            <input name="messageText" value={messageText} onChange={handleMessageChange} placeholder={t("message")} />
                        </Grid>
                        {!messageFile ? (
                            <Grid container item xs="auto" justifyContent="center" alignItems="center">
                                <input id="logo" type="file" name="messageFile" hidden onChange={handleFileChange} />
                                <label htmlFor="logo">
                                    <AttachCircle size="32" color="var(--primary-color)" variant="Bold" cursor="pointer" />
                                </label>
                            </Grid>
                        ) : (
                            <Grid className="chat-request__file" container item xs="auto" alignItems="center">
                                <Add color="var(--red-color)" onClick={removeFile} cursor="pointer" />
                                {messageFile && `${messageFile.name}`}
                            </Grid>
                        )}
                    </Grid>
                </Grid>
            ) : null}
            <BaseDialog open={open} handleClose={() => setOpen(false)} maxWidth="md" top="0" icon="back">
                <DialogContent dividers={true}>
                    <img className="chat-request__image-modal" src={image} />
                </DialogContent>
            </BaseDialog>
        </Grid>
    );
}

export default ChatRequest;
